import React from 'react';
import SvgIcon from './SvgIcon';

const Mute = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M15.75 8.25v-6L9 9H4.5a.75.75 0 00-.75.75v4.5a.75.75 0 00.75.75H9m2.025 2.025l4.725 4.725V12l-4.725 5.025zM23.25.75L.75 23.25"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Mute.displayName = 'MuteIcon';

export default Mute;
